import type { Transcripts } from '@trinity/chat/api/interfaces';
import type { UseDownloaderOptions } from '@trinity/chat-components/containers/QueryDownloader/index.js';
import { useQueryDownloader } from '@trinity/chat-components/containers/QueryDownloader/index.js';

type Data = Transcripts.DownloadSummary.Response;
type Params = ITranscriptId & {
  format: 'pptx' | 'docx';
  tagIds: number[];
};

type Options = Omit<UseDownloaderOptions<Data>, 'queryKey' | 'queryFn'>;

export const useDownloadTranscriptSummary = ({ format, tagIds, transcriptId }: Params, options: Options = {}) => {
  return useQueryDownloader({
    queryKey: [
      `get:transcripts/summary/export`,
      transcriptId,
      format,
      tagIds,
    ],
    queryFn: () => {
      /*return apiClient.downloadSummary({
        format,
        tagIds,
        transcriptId,
      });
      */
      return Promise.reject(new Error('Not implemented'));
    },
    meta: {
      downloader: true,
    },
    downloaderOptions: {
      onResponse: res => ({
        filename: res.name,
        type: 'blob',
        value: res.file,
      }),
    },
    ...options,
  });
};
